const Index = () => import('@/views/user/IndexView')
const RechargeCreate = () => import('@/views/user/RechargeCreate')
const Financials = () => import('@/views/user/FinancialIndex')
const Vips = () => import('@/views/user/VipIndex')

const Themes = () => import('@/views/theme/ThemeIndex')

const Activities = () => import('@/views/activity/ActivityIndex')
const ActivityDetail = () => import('@/views/activity/ActivityDetail')

const Customizes = () => import('@/views/customize/CustomizeIndex')

const Helps = () => import('@/views/help/HelpIndex')
const HelpDetail = () => import('@/views/help/HelpDetail')


export default [{
    path: '/',
    name: 'shouye',
    component: () => import('@/views/home/index'),
    meta: { title: '首页' }
  },{
    path: '/case',
    name: 'case',
    component: () => import('@/views/home/case'),
    meta: { title: '案例中心' }
  },{
    path: '/about',
    name: 'about',
    component: () => import('@/views/home/about'),
    meta: { title: '关于我们' }
  },{
    path: '/article/:id',
    name: 'article',
    component: () => import('@/views/home/article'),
    meta: { title: '文章' }
  },{
    path: '/help',
    name: 'help',
    component: () => import('@/views/home/help'),
    meta: { title: '帮助中心' }
  },{
    path: '/solution',
    name: 'solution',
    component: () => import('@/views/home/solution'),
    meta: { title: '解决方案' }
  },{
    path: '/product',
    name: 'product',
    component: () => import('@/views/home/product'),
    meta: { title: '产品服务' }
  },{
    path: '/advice',
    name: 'advice',
    component: () => import('@/views/home/advice'),
    meta: { title: '用户反馈' }
  },
  { 
    path: '/weixinlogin', 
    name: 'weixinlogin', 
    components:{
      main:() => import('@/views/home/weixinlogin')
    }, 
    meta: { title: '微信登录' } 
  },
  {
    path: '/index',
    name: 'home',
    redirect: '/index/main',
    component: () => import('@/views/home/HomeView'),
    meta: { title: '首页' },
    children: [
      
      { 
        path: '/index/main', 
        name: 'main', 
        components:{
          main:() => import('@/views/home/main')
        }, 
        meta: { title: '用户首页' } 
      },
      { 
        path: '/index/huiyuan', 
        name: 'huiyuan', 
        components:{
          main:() => import('@/views/home/huiyuan')
        }, 
        meta: { title: '活动管理' } 
      },{ 
        path: '/index/activity', 
        name: 'activity', 
        components:{
          main:() => import('@/views/home/activity')
        }, 
        meta: { title: '活动管理' } 
      },{ 
        path: '/index/templatecenter', 
        name: 'templatecenter', 
        components:{
          main:() => import('@/views/home/templatecenter')
        }, 
        meta: { title: '模版中心' } 
      },{ 
        path: '/index/createActivity', 
        name: 'createActivity', 
        components:{
          main:() => import('@/views/home/createActivity')
        }, 
        meta: { title: '创建活动' } 
      },{ 
        path: '/index/createActivity2', 
        name: 'createActivity2', 
        components:{
          main:() => import('@/views/home/createActivity2')
        }, 
        meta: { title: '创建活动' } 
      },{ 
        path: '/index/custom', 
        name: 'custom', 
        components:{
          main:() => import('@/views/home/custom')
        }, 
        meta: { title: '定制服务' } 
      },{ 
        path: '/index/helpcenter', 
        name: 'helpcenter', 
        components:{
          main:() => import('@/views/home/helpcenter')
        }, 
        meta: { title: '帮助中心' } 
      }
    ]
  }, {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/LoginView'),
    meta: { title: '登录' }
  }
]